import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import IndexAreas from '../index/IndexAreas';

class Conexiones extends Component {

  state = {
    data: IndexAreas[this.props.match.params.label][Number(this.props.match.params.position)]
  };

  render() {
  	return(
      <div id="page-wrapper">
        <div className="content">
          <div className="container">
            <center>
              <h2>{this.state.data.area}</h2>
            </center>
            <div id="carouselExampleIndicators" className="carousel slide" data-ride="carousel">
              <ol className="carousel-indicators">
                { this._renderPoints() }
              </ol>
              <div className="carousel-inner">
                { this._renderImages() }
              </div>
              <a className="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                <span className="sr-only">Anterior</span>
              </a>
              <a className="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                <span className="sr-only">Siguiente</span>
              </a>
            </div>
            <section className="col-12" style={{marginTop:"60px"}}>
               {/*<center> <span className="icon alt major iconosareas"><img src={"http://cdn.hidalgo.gob.mx/plantilla_secretarial/logos/areas/"+this.state.data.icon}></img></span></center>*/}
                <h3>{this.state.data.area}</h3>
                <p>{this.state.data.descripcion}</p>
            </section>
          </div> 
        </div>    
      </div>
  	);
  }

  _renderPoints = () => {
     return this.state.data.images.map((img, i) => {
      let active = "";
      if(i === 0){ active = "active" }
      return (
        <li data-target="#carouselExampleIndicators" data-slide-to="0" className={active}></li>
      );
    });
  };

  _renderImages = () => {
    return this.state.data.images.map((img, i) => {
      let active = "";
      if(i === 0){ active = "active" }
      return (
        <div className={"carousel-item "+active}>
          <img className="d-block w-100" alt="Imagen" src={img}></img>
        </div>
      );
    });
  };

}
 export default withRouter(Conexiones);


